import _ from "lodash";
import moment from "moment";
import http from "../http-common";
import { eventBus } from "./eventBus";

export default class BaseService {
	constructor(classPlural, params) {
		this.classPlural = classPlural;
		this.params = params;
		this.app = null;
	}

	setApp(app) {
		this.app = app;
	}

	async getAll(params = this.params) {
		return await http.get(`/${this.classPlural}`, { params });
	}

	async get(id, params = this.params) {
		return await http.get(`/${this.classPlural}/${id}`, { params });
	}

	async search(term, params) {
		return await http.get(`/${this.classPlural}/search/${term}`, { params });
	}

	async save(data) {
		if (_.isArray(data) && data.length == 1) {
			data = data[0];
		}

		if (_.isArray(data)) {
			for (var i in data) {
				if (data[i].id?.indexOf('-') === 0) {
					delete data[i].id;
				}
			}
		}
		else if (data.id?.indexOf('-') === 0) {
			delete data.id;
		}

		if (!data.id) {
			return await this.create(data);
		}
		else {
			return await this.update(data.id, data);
		}
	}

	async create(data) {
		data = this.cleanse(data);
		const result = await http.post(`/${this.classPlural}`, data);
		this.appSave(result.data.data);
		this.emitAll(result);
		return result;
	}

	async update(id, data) {
		data = this.cleanse(data);
		const result = await http.put(`/${this.classPlural}/${id}`, data);
		this.appSave(result.data.data);
		this.emitAll(result);
		return result;
	}

	patchAll(data) {
		data = this.cleanse(data);
		const promise = http.patch(`/${this.classPlural}`, data);
		promise.then(result => {
			this.appSave(result.data.data);
			this.emitAll(result);
		});
		return promise;
	}

	async delete(id) {
		const result = await http.delete(`/${this.classPlural}/${id}`);
		this.appDelete(id);
		this.emit('Deleted', id);
		return result;
	}

	async getChildren(id, childClass, params = this.params) {
		return await http.get(`/${this.classPlural}/${id}/${childClass}`, { params });
	}

	appSave(item) {
		if (this.app) {
			this.app.save(this.classPlural, item);
		}
	}

	appDelete(id) {
		if (this.app) {
			this.app.delete(this.classPlural, id);
		}
	}

	cleanse(data) {
		if (_.isArray(data)) {
			return _.map(data, obj => this.cleanse(obj));
		}
		else {
			data = _.mapValues(data, val => val instanceof moment ? val.valueOf() : val);
			return _.omitBy(data, _.isObjectLike);
		}
	}

	emit(action, id, data) {
		eventBus.emit(this.classPlural + action, id, data);
	}

	emitAll(result) {
		let data = result?.data?.data;
		if (data) {
			if (!_.isArray(data)) {
				data = [data];
			}
			_.forEach(data, d => {
				if( d.id ){
					eventBus.emit(this.classPlural + 'Updated', d.id, d);
				}
			});
		}
		if (result?.data?.metadata?.touched) {
			_.forOwn(result.data.metadata.touched, function (arr, key) {
				_.forEach(arr, id => {
					eventBus.emit(key + 'Touched', id);
				});
			});
		}
	}
}